import { adminLogin, adminList } from '@/api/admin'
import { apiAdminToUi } from '@/api/adapters'

const LOGIN_KEY = 'sys_login_ok'

export default {
  namespaced: true,
  state: {
    token: null,
    user: null,
    sessionActive: false
  },
  getters: {
    isAuthenticated(state) {
      return !!(state.sessionActive && state.token && state.user)
    }
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
    },
    SET_SESSION_ACTIVE(state, active) {
      state.sessionActive = !!active
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      state.sessionActive = false
    }
  },
  actions: {
    login({ commit }, { username, password, remember }) {
      return adminLogin({
        account: username.trim(),
        password
      }).then(res => {
        const d = res.data
        const user = apiAdminToUi(d)
        const token = d.token
        const storage = remember ? localStorage : sessionStorage
        storage.setItem(LOGIN_KEY, JSON.stringify({ token, user }))
        commit('SET_AUTH', { token, user })
        commit('SET_SESSION_ACTIVE', true)
        return user
      })
    },
    restore({ commit }) {
      const raw = localStorage.getItem(LOGIN_KEY) || sessionStorage.getItem(LOGIN_KEY)
      if (!raw) return Promise.resolve(false)
      try {
        const { token, user } = JSON.parse(raw)
        commit('SET_AUTH', { token, user })
        return adminList({ page: 1, page_size: 1 }, { silent: true })
          .then(() => {
            commit('SET_SESSION_ACTIVE', true)
            return true
          })
          .catch(err => {
            if (err && Number(err.code) === 401) {
              localStorage.removeItem(LOGIN_KEY)
              sessionStorage.removeItem(LOGIN_KEY)
              commit('CLEAR_AUTH')
            } else {
              commit('SET_SESSION_ACTIVE', false)
            }
            return false
          })
      } catch (e) {
        localStorage.removeItem(LOGIN_KEY)
        sessionStorage.removeItem(LOGIN_KEY)
        commit('CLEAR_AUTH')
        return Promise.resolve(false)
      }
    },
    logout({ commit }) {
      localStorage.removeItem(LOGIN_KEY)
      sessionStorage.removeItem(LOGIN_KEY)
      commit('CLEAR_AUTH')
    }
  }
}
